export function hasSubdomain(): boolean {
    const baseDomain = process.env.VUE_APP_DOMAIN!;
    const host = window.location.hostname;

    let subdomainPart = "";
    if (host === baseDomain) {
        subdomainPart = "";
    } else if (host.endsWith("." + baseDomain)) {
        subdomainPart = host.replace("." + baseDomain, "");
    } else {
        subdomainPart = host; // fallback (이상 케이스)
    }

    const isSub = !!subdomainPart && subdomainPart !== "www";
    const result = isSub && subdomainPart.split(".").filter(Boolean).length > 0;


    return result;
}

